import { secureGet } from '../utils/HttpUtils';

export interface OperationTypeDto {
  id: number;
  code: string;
  label: string;
}

export const getOperationTypes = async () => {
  return secureGet('/v1/private/application/operation-types');
};
